import React from "react";

const FeatureCard = (props) => {
  return (
    <>
      <div className="p-4 rounded-xl duration-500">
        <div className="rounded-xl mb-4 flex justify-center md:h-32 h-40">
          <img alt="img" src={props.img} className={props.classes} />
        </div>
        <h1 className="text-xl font-bold mb-3 break-words">{props.title}</h1>
        <p>{props.description}</p>
      </div>
    </>
  );
};

// hover:shadow-xl bg-orange-100 hover:bg-orange-200 transition-all

export default FeatureCard;
